import {
  startUserImpersonation,
  type ImpersonationCodeResponse,
  type StartImpersonationPayload,
} from '../../shared/api';

export const startProviderImpersonation = (
  providerId: number,
  payload?: StartImpersonationPayload
): Promise<ImpersonationCodeResponse> =>
  startUserImpersonation(providerId, payload);
